import { CalendarIcon } from '@WebComponents/svgs/icons/CalendarIcon';
import { css } from 'aphrodite';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useEventLogging } from '../../../../../../models/Logging';
import { Button } from '../../../../../components-v2/Button';
import { ROUTES } from '../../../../../constants/routes';
import { BriefDayGroup } from '../../../../../pages/MeetingPrepBriefs/helpers';
import { AgentRow, AgentRowIcon } from '../../AgentRow';
import { styleSheet } from '../../styles';
import { MEETING_PREP_TELEMETRY_CATEGORY } from './DashboardMeetingPrepRow';

export const DashboardMeetingPrepTodayDoneRow: FC<{ todayDay: BriefDayGroup }> = ({ todayDay }) => {
	const history = useHistory();
	const { logEvent } = useEventLogging(MEETING_PREP_TELEMETRY_CATEGORY);

	return (
		<AgentRow
			icon={
				<AgentRowIcon>
					<CalendarIcon />
				</AgentRowIcon>
			}
			title={
				<>
					{todayDay.preppedCount === 1 ? '1 meeting prepped' : `${todayDay.preppedCount} meetings prepped`}
					<span className={css(styleSheet.rowTitleMeta)}>Today · Meeting Prep Assistant</span>
				</>
			}
			detail='No more meetings today.'
			action={
				<Button
					size='sm'
					onClick={() => {
						logEvent('ViewBriefsClicked', { from: 'todayDone' });
						history.push(ROUTES.meetingPrep.briefs);
					}}
				>
					View briefs
				</Button>
			}
		/>
	);
};
